/** @typedef {{ id: string; label: string }} ProjectFormStep */

/** @type {ProjectFormStep[]} */
export const PROJECT_STEPS = [
  { id: "overview", label: "Project Details" },
  { id: "company", label: "Company Details" },
  { id: "team", label: "Who's Involved" },
  { id: "offering", label: "Offering Document" },
  { id: "newsUpdates", label: "News & Updates" },
];

export const PROJECT_STEP_IDS = PROJECT_STEPS.map((s) => s.id);
